import { resolveCibusPhase, type CibusOrderPhase, type CibusStatusAction, type OrderView } from 'shared-models/browser';

const PHASE_LABEL: Record<Exclude<CibusOrderPhase, 'unknown'>, string> = {
  new: 'ממתינה',
  accepted: 'בהכנה',
  sent: 'יצאה',
  canceled: 'בוטלה',
};

export function cibusStatusLabel(status: string | null | undefined): string {
  const phase = resolveCibusPhase(status);
  return phase === 'unknown' ? (status ?? '—') : PHASE_LABEL[phase];
}

// True while the package is absent from Cibus but not yet voided (first tick of the two-tick rule).
export function isCibusMissing(status: string | null | undefined): boolean {
  return status === 'MISSING';
}

// Buttons per phase; the second step reads "נאסף" for a pickup package.
export function visibleCibusActions(status: string | null | undefined): CibusStatusAction[] {
  switch (resolveCibusPhase(status)) {
    case 'new':
      return ['accept', 'reject'];
    case 'accepted':
      return ['sent'];
    default:
      return [];
  }
}

export function cibusActionLabel(action: CibusStatusAction, deliveryMethod: OrderView['cibusDeliveryMethod']): string {
  if (action === 'accept') {
    return 'קבל';
  }
  if (action === 'reject') {
    return 'דחה';
  }
  return deliveryMethod === 'pickup' ? 'נאסף' : 'יצא למשלוח';
}

export function cibusDeliveryLabel(deliveryMethod: OrderView['cibusDeliveryMethod']): string {
  return deliveryMethod === 'pickup' ? 'איסוף' : 'משלוח';
}

// Last four digits of the Cibus package id; short enough to read off a screen at a glance.
export function cibusShortId(cibusPackageId: string | null | undefined): string {
  return (cibusPackageId ?? '').replace(/\D/g, '').slice(-4);
}
